const Icon: React.FC<IconProps> = ({ color = "white", width = "26px", height = "26px" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_197_140)">
        <path d="M11.5 1.1C17 1.1 21.4 5.5 21.4 11C21.4 16.5 17 20.9 11.5 20.9C6 20.9 1.6 16.5 1.6 11C1.6 5.5 6 1.1 11.5 1.1ZM11.5 0C5.45 0 0.5 4.95 0.5 11C0.5 17.05 5.45 22 11.5 22C17.55 22 22.5 17.05 22.5 11C22.5 4.95 17.55 0 11.5 0ZM18.375 11C18.375 14.7583 15.2583 17.875 11.5 17.875C7.74167 17.875 4.625 14.7583 4.625 11C4.625 7.24167 7.74167 4.125 11.5 4.125C15.2583 4.125 18.375 7.24167 18.375 11ZM9.3 7.7V14.3L14.9833 11L9.3 7.7Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_197_140">
          <rect width="22" height="22" fill={color} transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
